<mat-card>
  <mat-card-content>
    <table class="user-table">
      <thead>
        <tr>
          <th>Name</th>
          <th>E-Mail</th>
          <th>City</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let user of allUsers" [routerLink]="['/user', user.id]">
          <td>{{ user.firstName }} {{ user.lastName }}</td>
          <td>{{ user.mail }}</td>
          <td>{{ user.city }}</td>
        </tr>
      </tbody>
    </table>
  </mat-card-content>
</mat-card>

<button
  (click)="openDialog()"
  class="add-user-btn"
  matTooltip="Add user"
  matTooltipPosition="above"
  mat-fab
  color="primary"
>
  <mat-icon>add</mat-icon>
</button>
